
export function sendInsightMessage(messageKey: string, message: string, actionMessage: string, contextData: any = {}): void {

    const notifications = Office.context.mailbox.item?.notificationMessages;
    const itemId = Office.context.mailbox.item?.itemId;
    const details = {
        type: Office.MailboxEnums.ItemNotificationMessageType.InsightMessage,
        message: message,
        icon: "Icon.80x80",
        actions: [
            {
                actionText: actionMessage,
                actionType: Office.MailboxEnums.ActionType.ShowTaskPane,
                commandId: (itemId === undefined ? "" : 'msgReadOpenPaneButton'),
                contextData: contextData
            }
        ]
    }

    notifications?.addAsync(messageKey, details, (result: Office.AsyncResult<void>) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
        } else {
            console.error(`Failed to add insight message '${messageKey}':`, result.error);
        }
    });
}